/**
 * Loader para templates JSON dinamicamente
 * Carrega templates de temas para o wizard de onboarding
 */

// Importar todos os templates de forma estática para que o Vite possa resolver
import aesthetics from '../themes/templates/aesthetics.json';
import barbershop from '../themes/templates/barbershop.json';
import beautySalon from '../themes/templates/beauty-salon.json';
import clinic from '../themes/templates/clinic.json';
import defaultTemplate from '../themes/templates/default.json';
import dental from '../themes/templates/dental.json';
import massage from '../themes/templates/massage.json';
import medical from '../themes/templates/medical.json';
import psychology from '../themes/templates/psychology.json';
import tattooStudio from '../themes/templates/tattoo-studio.json';
import therapy from '../themes/templates/therapy.json';

const templates = {
  aesthetics,
  barbershop,
  'beauty-salon': beautySalon,
  clinic,
  default: defaultTemplate,
  dental,
  massage,
  medical,
  psychology,
  'tattoo-studio': tattooStudio,
  therapy,
};

export const loadTemplate = async (templateId) => {
  try {
    const template = templates[templateId];
    if (!template) {
      throw new Error(`Template não encontrado: ${templateId}`);
    }
    return template;
  } catch (error) {
    console.error(`[TemplateLoader] Erro ao carregar template: ${templateId}`, error);
    throw new Error(`Falha ao carregar template: ${templateId}`);
  }
};

/**
 * Lista todos os templates disponíveis
 */
export const listAvailableTemplates = async () => {
  const templateIds = [
    'aesthetics',
    'barbershop',
    'beauty-salon',
    'clinic',
    'default',
    'dental',
    'massage',
    'medical',
    'psychology',
    'tattoo-studio',
    'therapy',
  ];

  const templates = await Promise.all(
    templateIds.map(async (id) => {
      try {
        const template = await loadTemplate(id);
        return {
          id: template.id,
          name: template.name,
          description: template.description,
          colors: template.colors,
          icons: template.icons,
        };
      } catch (error) {
        console.warn(`[TemplateLoader] Falha ao carregar template ${id}`, error);
        return null;
      }
    })
  );

  return templates.filter((t) => t !== null);
};
